<template>
  <div>
    <wc-dialog
      :showDialog='showDialog'
      :title='title'
      :icon='icon'
      :iconColor='iconColor'
      :cancelText='cancelText'
      :cancelColor='cancelColor'
      :color='color'
      :hideCancel='hideCancel'
      :saveText='saveText'
      :saveColor='saveColor'
      :width='width'
      :loading='loading'
      :loadingButtons='loading'
      @cancel="$emit('cancel')"
      @save="$emit('confirm')"
    >
      <slot></slot>
    </wc-dialog>
  </div>
</template>

<script>
/*
Generally, this will be used to confirm the deletion of some
object. Of course, it's flexible enough for other options too.

Basically, we are warning the user to be careful with their actions here.
*/

export default {
  name: 'wc-confirm',
  props: {
    title: {
      required: false,
      default: 'Are you sure?'
    },
    cancelText: {
      required: false,
      default: 'Cancel'
    },
    cancelColor: {
      required: false,
      default: ''
    },
    color:{
      required: false,
      default: 'primary'
    },
    saveText: {
      required: false,
      default: 'Confirm'
    },
    saveColor: {
      required: false,
      default: 'error'
    },
    icon: {
      required: false,
      default: 'mdi-alert'
    },
    iconColor: {
      required: false,
      default: 'white'
    },
    showDialog: {
      required: true,
      type: Boolean
    },
    hideCancel: {
      required: false,
      type: Boolean,
      default: false
    },
    loading: {
      required: false,
      type: Boolean,
      default: false
    },
    width: {
      required: false,
      default: '350'
    }
  }
}

</script>
